/**
 * Loads environment variables (React loads .env files automatically)
 * React will automatically load .env.${NODE_ENV}.local, .env.${NODE_ENV}, .env.local, and .env files
 */
export function loadEnvironment(): void {
  const nodeEnv = process.env.NODE_ENV || 'development';

  console.log(`✓ Environment: ${nodeEnv}`);
  console.log(`✓ React automatically loaded environment variables`);

  // Validate required environment variables
  validateRequiredEnvVars();
}

/**
 * Validates that required environment variables are present
 */
function validateRequiredEnvVars(): void {
  const requiredVars = [
    'REACT_APP_DAPP_CONTRACT',
    'REACT_APP_COLLATERAL_CONTRACT',
    'REACT_APP_ORACLE_CONTRACT',
    'REACT_APP_FEE_ESCROW_CONTRACT'
  ];

  const missing = requiredVars.filter(varName => !process.env[varName]);

  if (missing.length > 0) {
    console.error('❌ Missing required environment variables:', missing);
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`);
  }

  console.log('✓ All required environment variables are present');
}

/**
 * Gets the current environment configuration
 * Prioritizes runtime config over build-time environment variables
 */
export function getEnvConfig() {
  // Check for runtime configuration first (Docker/production)
  const runtimeConfig = (window as any).APP_CONFIG;

  if (runtimeConfig) {
    return {
      nodeEnv: runtimeConfig.NODE_ENV || process.env.NODE_ENV || 'development',
      port: process.env.PORT || '3000',
      contracts: {
        dapp: runtimeConfig.contracts?.dapp || process.env.REACT_APP_DAPP_CONTRACT,
        collateral: runtimeConfig.contracts?.collateral || process.env.REACT_APP_COLLATERAL_CONTRACT,
        oracle: runtimeConfig.contracts?.oracle || process.env.REACT_APP_ORACLE_CONTRACT,
        feeEscrow: runtimeConfig.contracts?.feeEscrow || process.env.REACT_APP_FEE_ESCROW_CONTRACT
      }
    };
  }

  // Fallback to build-time environment variables (development)
  return {
    nodeEnv: process.env.NODE_ENV || 'development',
    port: process.env.PORT || '3000',
    contracts: {
      dapp: process.env.REACT_APP_DAPP_CONTRACT,
      collateral: process.env.REACT_APP_COLLATERAL_CONTRACT,
      oracle: process.env.REACT_APP_ORACLE_CONTRACT,
      feeEscrow: process.env.REACT_APP_FEE_ESCROW_CONTRACT
    }
  };
}

// Load environment variables immediately when this module is imported
loadEnvironment();